import { render, staticRenderFns } from "./page-navigate-win3.vue?vue&type=template&id=2f760a13&scoped=true&"
import script from "./page-navigate-win3.vue?vue&type=script&lang=js&"
export * from "./page-navigate-win3.vue?vue&type=script&lang=js&"
import style0 from "./page-navigate-win3.vue?vue&type=style&index=0&id=2f760a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f760a13",
  null
  
)

export default component.exports